import React, { useState } from 'react';
import {
  Grid, Backdrop, Snackbar, CircularProgress, Typography, Modal, Box, TextField, Stack, Stepper, Step, StepLabel, StepButton,
  createTheme,
  Autocomplete,
  List,
  ListItem,
  ListItemText,
  IconButton,
  Paper,
  Table,
  TableContainer,
  TableBody,
  TableRow,
  TableCell,
  Tooltip,
  TableSortLabel,
  TableHead
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import ThemeCustomization from 'src/themesNew';
import Alert from 'src/components/Alert';
import Page1 from 'src/components/Page';
import axios from 'src/utils/axios';
import SearchIcon from '@mui/icons-material/Search';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import CableIcon from '@mui/icons-material/Cable';
import VisibilityIcon from '@mui/icons-material/Visibility';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import SaveIcon from '@mui/icons-material/Save';
import DejaVuSans from 'src/assets/font/DejaVuSans.ttf';
import TextFieldsIcon from '@material-ui/icons/TextFields';
import EmailIcon from '@mui/icons-material/Email';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import PlaylistAddCheckIcon from '@mui/icons-material/PlaylistAddCheck';
import CloudOffIcon from '@mui/icons-material/CloudOff';
import {
  Container,
  Card,
  CardHeader,
  CardActions,
  CardContent,
  Divider,
  DialogContent,
  DialogTitle,
  Dialog,
  DialogActions,
  DialogContentText,
  Button,
  Checkbox
} from '@material-ui/core';
import Chip from '@mui/material/Chip';
import { ThemeProvider, makeStyles } from '@material-ui/styles';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import trLocale from 'date-fns/locale/tr';
import * as pdfjsLib from 'pdfjs-dist';
import html2pdf from 'html2pdf.js';
import CloseIcon from '@material-ui/icons/Close';
import moment from 'moment';
import TechGptChatbox from 'src/components/TechGpt/TechGptChatbox'
import AddIcon from '@mui/icons-material/Add';
import { Viewer } from '@react-pdf-viewer/core';
import { toolbarPlugin } from '@react-pdf-viewer/toolbar';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import LibraryAddIcon from '@mui/icons-material/LibraryAdd';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import FolderOpenIcon from '@mui/icons-material/FolderOpen';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
// Stil dosyaları
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/toolbar/lib/styles/index.css';

const materialTheme = createTheme({
  palette: {
    primary: {
      contrastText: '#FF9800',
      dark: '#424242',
      main: '#424242',
      light: '#424242'
    }
  }
});

const localeMap = {
  tr: trLocale
};

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));

// Add this modal style after useStyles
const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '80%',
  maxHeight: '80vh',
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  overflowY: 'auto',
  borderRadius: '8px'
};

const FileManagement = () => {
  const theme = useTheme();
  const classes = useStyles();

  const toolbarPluginInstance = toolbarPlugin();
  const { Toolbar } = toolbarPluginInstance;

  const toolbarPluginInstance2 = toolbarPlugin(); // 2. PDF viewer için
  const { Toolbar: Toolbar2 } = toolbarPluginInstance2;

  const [loading, setLoading] = useState(false);
  const [uyari, setUyari] = useState(false);
  const [uyariTip, setUyariTip] = useState('default');
  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState("");
  const [documentStatusData, setDocumentStatusData] = useState(null); // object
  const [documentStatus, setDocumentStatus] = useState(''); // fallback hata mesajı
  const [documentSummaryPopUp, setDocumentSummaryPopUp] = useState(false);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [accumulatedUrunListesi, setAccumulatedUrunListesi] = useState([]);
  const [text, setText] = useState("");
  const [llmSummary, setllmSummary] = useState("");
  const [llmDetail, setllmDetail] = useState("");
  const [activeStep, setActiveStep] = useState(null);
  const [responseMessage, setResponseMessage] = useState({
    ErrorCode: '0',
    ErrorDescription: 'success_message'
  });
  const [chunks, setChunks] = useState([]);
  const [base64PDF, setBase64PDF] = useState(''); // Base64 PDF çıktısı için yeni state
  const [openModal, setOpenModal] = useState(false);
  const [techGptPopUp, setTechGptPopUp] = useState(false);
  const [bankNoInput, setBankNoInput] = useState("");
  const [bankaAciklamaInput, setBankaAciklamaInput] = useState("");
  const [dosyaLinkAciklamaInput, setDosyaLinkAciklamaInput] = useState("");
  const [bankaKodu, setBankaKodu] = useState("");
  const [documentList, setDocumentList] = useState([]);
  const [bankTypes, setBankTypes] = useState([]);
  const [selectedBankType, setSelectedBankType] = useState(null);
  const [selectedBankFilterType, setSelectedBankFilterType] = useState(null);
  const [mainGroups, setMainGroups] = useState([]);
  const [selectedMainGroupFilter, setSelectedMainGroupFilter] = useState(null);
  const [selectedMainGroups, setSelectedMainGroups] = useState(null);
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [models, setModels] = useState([]);
  const [selectedModels, setSelectedModels] = useState([]);

  const [productsData, setProductsData] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [productInputValue, setProductInputValue] = useState("");
  const [documentBankNoList, setDocumentBankNoList] = useState([]);

  const [bulkModelUploadPopUp, setBulkModelUploadPopUp] = useState(false);
  const [bulkUserModelCodes, setBulkUserModelCodes] = useState('');

  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [confirmDialogAction, setConfirmDialogAction] = useState(null);

  const openConfirmDialog = (action) => {
    setConfirmDialogAction(() => action);
    setConfirmDialogOpen(true);
  };

  const handleConfirmDialogClose = () => {
    setConfirmDialogOpen(false);
    setConfirmDialogAction(null);
  };

  const handleConfirmDialogConfirm = () => {
    if (confirmDialogAction) confirmDialogAction();
    setConfirmDialogOpen(false);
    setConfirmDialogAction(null);
  };

  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('BANKAKODU');
  const [modelOrder, setModelOrder] = React.useState('asc');
  const [modelOrderBy, setModelOrderBy] = React.useState('KUL_MODEL_KODU');

  const [bulkUserModelCodeLoading, setBulkUserModelCodeLoading] = useState(false);
  const [documentLoading, setDocumentLoading] = useState(false);
  const [productLoading, setProductLoading] = useState(false);
  const [banktypeLoading, setBanktypeLoading] = useState(false);
  const [mainGroupLoading, setMainGroupLoading] = useState(false);
  const [modelLoading, setModelLoading] = useState(false);
  const [fileLoading, setFileLoading] = useState(false);
  const [fileOutputLoading, setFileOutputLoading] = useState(false);
  const [loadingBankNo, setLoadingBankNo] = useState(null);
  const [teknisyenKocuAktiflik, setTeknisyenKocuAktiflik] = useState(null);
  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" style={{ color: '#FF9800' }} />;


  const [talepEdilmeBaslangicTarihi, setTalepEdilmeBaslangicTarihi] = useState(
    new Date(new Date().getFullYear(), 0, 1).toString() // Bulunduğumuz yılın ilk ayının ilk günü gelmesi istenmiştir.
  );

  const [talepEdilmeBitisTarihi, setTalepEdilmeBitisTarihi] = useState(
    new Date().toString()
  );

  React.useEffect(() => {
    getUploadedDocumentList();
  }, [talepEdilmeBaslangicTarihi, talepEdilmeBitisTarihi]);


  React.useEffect(() => {
    pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.0.279/pdf.worker.min.js';
  }, []);

  React.useEffect(() => {
    getBankTypes();
    getMainGroups();
    getModels('');
  }, []);

  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') return;
    setUyari(false);
  };

  const getUploadedDocumentList = () => {
    if (talepEdilmeBaslangicTarihi && talepEdilmeBitisTarihi) {
      const formattedBaslangicDate = moment(talepEdilmeBaslangicTarihi).format("MM-DD-YYYY");
      const formattedBitisDate = moment(talepEdilmeBitisTarihi).format("MM-DD-YYYY");
      setDocumentLoading(true);
      axios.get(`/GetTeknisyenKocuUploadedFiles/${formattedBaslangicDate}/${formattedBitisDate}`)
        .then((response) => {
          const data = response.data;
          setDocumentList(Array.isArray(data) ? data : []);
          setDocumentLoading(false);
        }).catch((err) => {
          setDocumentLoading(false);
        });
    }
  }

  const getBankTypes = () => {
    setBanktypeLoading(true);
    axios.get('/GetBankTypes')
      .then((response) => {
        const data = response.data;
        setBankTypes(data);
        setBanktypeLoading(false);
      }).catch((err) => {
        setBanktypeLoading(false);
      });
  }

  const getMainGroups = () => {
    setMainGroupLoading(true);
    axios.get('/GetMainProductGroup')
      .then((response) => {
        const data = response.data;
        setMainGroups(data);
        setMainGroupLoading(false);
      }).catch((err) => {
        setMainGroupLoading(false);
      });
  }

  const getModels = (search) => {
    setModelLoading(true);
    axios.get(`GetModelsForDocument?Search=${search}`)
      .then((response) => {
        const data = response.data;
        if (data && data !== '')
          setModels(data);
        setModelLoading(false);
      }).catch((err) => {
        setModelLoading(false);
      });
  }

  const handleUploadFile = (event) => {
    const selectedFile = event.target.files[0];
    // setFileName(selectedFile.name); // dosya adı olarak artık bankaNo dosya adı kullanılacak. Örn "91528.pdf"
    if (selectedFile && selectedFile.type === 'application/pdf') {
      setLoading(true);
      const fileURL = URL.createObjectURL(selectedFile);
      setFile(fileURL);

      const formData = new FormData();
      formData.append("file", selectedFile);

      formData.append("MainProductGroup", selectedMainGroups.ANA_GRUP_KODU);
      formData.append("BankType", selectedBankType.BANKATIPI);
      formData.append("BankDescription", bankaAciklamaInput);
      formData.append("BankCode", bankaKodu);
      selectedModels.forEach(m => {
        formData.append("Models", m.MODEL_KODU);
      });

      // const bankaNoArray = bankNoInput
      //   .split(",")
      //   .map(num => num.trim())
      //   .filter(num => num.length > 0)
      //   .map(num => Number(num));

      // formData.append("metadata", JSON.stringify({
      //   BankaNo: bankaNoArray
      // }));

      axios.post("/TeknisyenGptUploadFile", formData
      ).then(response => {
        const data = response.data;
        if (data.ErrorCode === "0") {
          const dosyaAdi = String(data.BankNo) + '.pdf';
          setFileName(dosyaAdi);
          setBankNoInput(String(data.BankNo))
          setResponseMessage({
            ErrorCode: data.ErrorCode,
            ErrorDescription: data.ErrorDescription
          });
          setUyariTip('success');
          setUyari(true);



          setSelectedBankType(null);
          setSelectedMainGroups(null);
          setBankaAciklamaInput("");
          setSelectedModels([]);
          setBankaKodu("");

          getUploadedDocumentList();
        } else {
          setResponseMessage({
            ErrorCode: data.ErrorCode,
            ErrorDescription: data.ErrorDescription
          });
          setUyariTip('error');
          setUyari(true);
        }
        setLoading(false);
      }).catch((error) => {
        setLoading(false);
      });
    }
  }

  const handleGetStatusOfDocument = () => {
    if (fileName.length <= 0) {
      setResponseMessage({
        ErrorCode: '1000',
        ErrorDescription: 'Lütfen önce bir dosya yükleyiniz!...'
      });
      setUyariTip('error');
      setUyari(true);
      return;
    }
    setLoading(true);
    axios.get(`/GetDocumentStatus/${fileName}`)
      .then(response => {
        const data = response.data;
        if (data?.message === 'success' && data?.content) {
          setDocumentStatusData(data.content);
          setDocumentSummaryPopUp(true);
        } else {
          setResponseMessage({
            ErrorCode: '1000',
            ErrorDescription: data?.message ?? 'Dosya Bulunamadı!...'
          });
          setUyariTip('error');
          setUyari(true);
        }
        setLoading(false);
      })
      .catch(error => {
        setLoading(false);
        setDocumentStatusData(null);
      });
  }

  const handleIndexingDocument = () => {
    if (fileName.length <= 0) {
      setResponseMessage({
        ErrorCode: '1000',
        ErrorDescription: 'Lütfen önce bir dosya yükleyiniz!...'
      });
      setUyariTip('error');
      setUyari(true);
      return;
    }
    setLoading(true);

    axios.get(`/GetDocumentStatus/${fileName}`)
      .then(statusResponse => {
        const statusData = statusResponse.data;
        if (!(statusData?.message === 'success' && statusData?.content)) {
          setResponseMessage({
            ErrorCode: '1000',
            ErrorDescription: 'Dosya Bulunamadı!...'
          });
          setUyariTip('error');
          setUyari(true);
          setLoading(false);
          return;
        }

        // Index öncesi durum kontrolü
        const documentStatus = statusData.content.status;
        if (documentStatus !== "InReview") {
          setResponseMessage({
            ErrorCode: '1001',
            ErrorDescription: `Belge "${documentStatus}" durumunda, kaydetme yapılamaz!`
          });
          setUyariTip('warning');
          setUyari(true);
          setLoading(false);
          return;
        }

        const data = {
          fileName: fileName
        };
        axios.post("/TeknisyenGptIndexingDocument", data
        ).then(indexResponse => {
          const result = indexResponse.data;
          if (result.ErrorCode === "0") {
            setResponseMessage({
              ErrorCode: result.ErrorCode,
              ErrorDescription: result.ErrorDescription
            });
            setUyariTip('success');
            setUyari(true);
          } else {
            setResponseMessage({
              ErrorCode: result.ErrorCode,
              ErrorDescription: result.ErrorDescription
            });
            setUyariTip('error');
            setUyari(true);
          }
          setLoading(false);
        }).catch((error) => {
          setLoading(false);
        });

      })
      .catch(error => {
        setLoading(false);
        setDocumentStatusData(null);
      });
  }

  const handleGetRagReadyDocument = () => {
    if (fileName.length <= 0) {
      setResponseMessage({
        ErrorCode: '1000',
        ErrorDescription: 'Lütfen önce bir dosya yükleyiniz!...'
      });
      setUyariTip('error');
      setUyari(true);
      return;
    }

    setFileOutputLoading(true);
    axios.get(`/GetDocumentStatus/${fileName}`)
      .then(statusResponse => {
        const statusData = statusResponse.data;
        if (!(statusData?.message === 'success' && statusData?.content)) {
          setResponseMessage({
            ErrorCode: '1000',
            ErrorDescription: 'Dosya Bulunamadı!...'
          });
          setUyariTip('error');
          setUyari(true);
          setFileOutputLoading(false);
          return;
        }

        // Sonuç Gösterme öncesi durum kontrolü
        const documentStatus = statusData.content.status;
        if (documentStatus == "Pending" || documentStatus == "Failed") {
          setResponseMessage({
            ErrorCode: '1001',
            ErrorDescription: `Belge "${documentStatus}" durumunda, sonuç gösterilemez.`
          });
          setUyariTip('warning');
          setUyari(true);
          setFileOutputLoading(false);
          return;
        }

        axios.get(`/GetRagReadyDocument/${fileName}`, {
          responseType: 'blob'
        })
          .then(response => {
            const blob = new Blob([response.data], { type: 'application/pdf' });
            const url = URL.createObjectURL(blob);
            setPdfUrl(url);
            setFileOutputLoading(false);
          })
          .catch(error => {
            setFileOutputLoading(false);
            setResponseMessage({
              ErrorCode: '1000',
              ErrorDescription: 'PDF alınırken hata oluştu.'
            });
            setUyariTip('error');
            setUyari(true);
          });

      })
      .catch(error => {
        setFileOutputLoading(false);
        setDocumentStatusData(null);
      });
  };


  const handleDeleteDocument = () => {
    if (fileName.length <= 0) {
      setResponseMessage({
        ErrorCode: '1000',
        ErrorDescription: 'Lütfen önce bir dosya yükleyiniz!...'
      });
      setUyariTip('error');
      setUyari(true);
      return;
    }

    const data = {
      fileName: fileName,
      bankNo: bankNoInput
    };
    setLoading(true);
    axios.post("/SetDeleteDocument", data
    ).then(response => {
      const result = response.data;

      if (result.ErrorCode === "0") {
        setResponseMessage({
          ErrorCode: result.ErrorCode,
          ErrorDescription: result.ErrorDescription
        });
        setUyariTip('success');
        setUyari(true);

        // Temizlik İşlemleri
        setPdfUrl(null);
        setDocumentStatusData(null);
        setFile(null);
        setFileName("");
        setBankNoInput("");
        setSelectedBankType(null);
        setSelectedMainGroups(null);
        setBankaAciklamaInput("");

        getUploadedDocumentList();
      } else {
        setResponseMessage({
          ErrorCode: result.ErrorCode,
          ErrorDescription: result.ErrorDescription || "Silme işlemi başarısız!"
        });
        setUyariTip('error');
        setUyari(true);

      }
      setLoading(false);
    }).catch((error) => {
      setLoading(false);
    });
  }

  const steps = [
    {
      label: "Sonuç Göster",
      icon: <VisibilityIcon />,
      onClick: () => handleGetRagReadyDocument(),
    },
    {
      label: "Kaydet",
      icon: <CableIcon />,
      onClick: () => handleIndexingDocument(),
    },
    {
      label: "Sil",
      icon: <DeleteForeverIcon />,
      onClick: () => openConfirmDialog(handleDeleteDocument),
    },
  ];

  const handleStep = (index, onClickFn) => {
    setActiveStep(index); // seçilen step highlight olacak
    if (onClickFn) onClickFn();
  };

  const handleChatBox = () => {
    if (!bankNoInput || !String(bankNoInput).trim()) {
      setResponseMessage({
        ErrorCode: '1000',
        ErrorDescription: 'Lütfen önce banka no giriniz!...'
      });
      setUyariTip('error');
      setUyari(true);
      return;
    }
    setTechGptPopUp(true);
  }

  const handleChangeSelectedDocument = (event, newValue) => {
    setSelectedProduct(null);
    setFile(null);
    setPdfUrl(null);
    setDocumentStatusData(null);
    setDocumentBankNoList([]);

    if (newValue) {
      const dosyaAdi = String(newValue.BANKA_NO) + '.pdf';
      setFileName(dosyaAdi);
      setBankNoInput(String(newValue.BANKA_NO));

      setPdfUrl(null);
      setDocumentStatusData(null);
      setFile(null);

      openDocumentInline(newValue.BANKA_NO)
    } else {
      setFileName("");
      setBankNoInput("");
      setPdfUrl(null);
      setDocumentStatusData(null);
      setFile(null);
      setSelectedBankType(null);
      setSelectedMainGroups(null);
      setBankaKodu("");
      setBankaAciklamaInput("");
      setDosyaLinkAciklamaInput("");
      setSelectedModels([]);
      setTeknisyenKocuAktiflik(null);
    }
  }

  const handleChangeBankType = (newValue) => {
    if (newValue) {
      setSelectedBankType(newValue);
    }
  }

  const handleClearEverything = () => {
    setFile(null);
    setPdfUrl(null);
    setDocumentStatusData(null);
    setSelectedBankType(null)
    setSelectedDocument(null)
    setSelectedMainGroups(null)
    setSelectedProduct(null)
    setTeknisyenKocuAktiflik(null);

    setFileName("");
    setBankNoInput("");
    setBankaAciklamaInput("");
    setDosyaLinkAciklamaInput("");
    setSelectedModels([]);
    setBankaKodu("");
    setProductInputValue("");
    setDocumentBankNoList([]);
  }

  const handleToggleAktiflik = (targetValue) => {
    if (bankNoInput === '' || bankNoInput === null) return;
    const newAktiflik = targetValue;
    const data = {
      BankaNo: parseInt(bankNoInput),
      isActive: newAktiflik == true ? 1 : 0
    };
    setLoading(true);
    axios.post('/SetTeknisyenKocuDokumanAktiflik', data)
      .then(response => {
        const result = response.data;
        if (result.ErrorCode === '0') {
          setTeknisyenKocuAktiflik(newAktiflik);

          setResponseMessage({
            ErrorCode: result.ErrorCode,
            ErrorDescription: result.ErrorDescription
          });
          setUyariTip('success');
          setUyari(true);
        } else {
          setResponseMessage({
            ErrorCode: result.ErrorCode,
            ErrorDescription: result.ErrorDescription || 'İşlem başarısız!'
          });
          setUyariTip('error');
          setUyari(true);
        }
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const handleUpdateDocument = () => {

    const data = {
      bankaNo: parseInt(bankNoInput),
      bankaTipi: selectedBankType.BANKATIPI,
      anaGrupKodu: selectedMainGroups.ANA_GRUP_KODU,
      dosyaAciklamasi: bankaAciklamaInput,
      bankaKodu: bankaKodu,
      selectedModels: selectedModels.map(m => m.MODEL_KODU),
      dosyaLinkAciklama: dosyaLinkAciklamaInput ? dosyaLinkAciklamaInput : ''
    };
    setLoading(true);
    axios.post("/TeknisyenKocuDocumentUpdateArekInfo", data
    ).then(response => {
      const result = response.data;

      if (result.ErrorCode === "0") {
        setResponseMessage({
          ErrorCode: result.ErrorCode,
          ErrorDescription: result.ErrorDescription
        });
        setUyariTip('success');
        setUyari(true);
      } else {
        setResponseMessage({
          ErrorCode: result.ErrorCode,
          ErrorDescription: result.ErrorDescription || "Kaydedilemedi!"
        });
        setUyariTip('error');
        setUyari(true);
      }
      setLoading(false);
    }).catch((error) => {
      setLoading(false);
    });
  }

  const openDocumentInline = (bankNo) => {
    setFileLoading(true);
    setLoadingBankNo(bankNo);
    axios.get(`/GetTeknisyenKocuRelatedDocument/${bankNo}`)
      .then((response) => {

        const base64Data = response.data[0].DocumentData;

        setSelectedBankType(bankTypes.find(bank => bank.BANKATIPI === response.data[0].BANKATIPI));
        setSelectedMainGroups(mainGroups.find(group => group.ANA_GRUP_KODU === response.data[0].ANA_GRUP_KODU));
        setBankaAciklamaInput(response.data[0].Description);
        setBankaKodu(response.data[0].BankaKodu);
        setDosyaLinkAciklamaInput(response.data[0].MOBIL_TEXT);
        setTeknisyenKocuAktiflik(response.data[0].TeknisyenKocuAktiflik);
        const rawModels = response.data[0].ModelKodlari;
        let parsedModels = [];
        try {
          parsedModels = rawModels ? JSON.parse(rawModels) : [];
        } catch (e) {
          parsedModels = [];
        }
        setSelectedModels(parsedModels);


        // Base64 -> Blob
        const byteCharacters = atob(base64Data);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);

        const blob = new Blob([byteArray], { type: "application/pdf" });
        const url = URL.createObjectURL(blob);

        setFile(url);
        setFileLoading(false);
        setLoadingBankNo(null);
      })
      .catch((error) => {
        setFileLoading(false);
        setLoadingBankNo(null);
        console.error("Döküman yüklenirken hata oluştu:", error);
      });
  };

  const handleGetProductsBySearchTerm = (searchTerm) => {
    setProductLoading(true);
    axios.get(`/GetProductsBySearchTerm/${searchTerm}`)
      .then((response) => {
        const data = response.data;
        setProductsData(data);
        setProductLoading(false);
      }).catch((err) => {
        setProductLoading(false);
      });
  }

  const handleChangeSelectedProduct = (event, newValue) => {
    setFile(null);
    setPdfUrl(null);
    setDocumentStatusData(null);

    setSelectedProduct(newValue);

    if (newValue) {
      const userModelCode = newValue.KUL_MODEL_KODU;
      setLoading(true);
      axios.get(`/GetBankNoForTeknisyenKocu/${userModelCode}`)
        .then((response) => {
          const data = response.data;
          setDocumentBankNoList(data ? data : []);

          let bankNoList = [];
          data.map((x) => {
            bankNoList.push(x.BANKANO);
          })
          setBankNoInput(bankNoList.toString());

          setLoading(false);
        }).catch((err) => {
          setLoading(false);
        });
    } else {
      setDocumentBankNoList([]);
    }

  }

  const handleSaveBulkUserModelCodes = () => {
    const userModelCodeList = bulkUserModelCodes.split("\n")
      .map(l => l.trim())
      .filter(l => l !== "");

    let fetchedModels = [];
    let completed = 0;

    setBulkUserModelCodeLoading(true);
    userModelCodeList.forEach(modelCode => {
      axios.get(`GetModelsForDocument?Search=${modelCode}`)
        .then((response) => {
          const data = response.data;
          if (data && data.length > 0) {
            fetchedModels.push(data[0]);
          }
          completed++;
          if (completed === userModelCodeList.length) {
            setSelectedModels(prev => {
              const merged = [...prev, ...fetchedModels];
              return merged.filter(
                (item, index, self) =>
                  index === self.findIndex(i => i.MODEL_KODU === item.MODEL_KODU)
              );
            });
            setBulkUserModelCodeLoading(false);
            setBulkModelUploadPopUp(false);
            setBulkUserModelCodes('');
          }
        })
        .catch((err) => {
          completed++;

          if (completed === userModelCodeList.length) {
            setSelectedModels(prev => {
              const merged = [...prev, ...fetchedModels];
              return merged.filter(
                (item, index, self) =>
                  index === self.findIndex(i => i.MODEL_KODU === item.MODEL_KODU)
              );
            });
            setBulkUserModelCodeLoading(false);
            setBulkModelUploadPopUp(false);
            setBulkUserModelCodes('');
          }
        });
    });

  }

  const handleRemoveModel = (modelToRemove) => {
    const newSelection = selectedModels.filter(
      (m) => m.MODEL_KODU !== modelToRemove.MODEL_KODU
    );
    setSelectedModels(newSelection);
  };

  function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }

  function getComparator(order, orderBy) {
    return order === 'desc'
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }

  function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) {
        return order;
      }
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }
  // Sıralama Tetikleyici
  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  // Tıklanınca Sıralama Yönü Iconunu Oluşturan Helper
  const createSortHandler = (property) => (event) => {
    handleRequestSort(property);
  };

  const handleRequestModelSort = (property) => {
    const isAsc = modelOrderBy === property && modelOrder === 'asc';
    setModelOrder(isAsc ? 'desc' : 'asc');
    setModelOrderBy(property);
  };

  const createModelSortHandler = (property) => (event) => {
    handleRequestModelSort(property);
  };

  const handleSendMail = () => {
    if (bankNoInput === '' || bankNoInput === null) {
      setResponseMessage({
        ErrorCode: '1000',
        ErrorDescription: 'Lütfen önce banka no seçiniz!...'
      });
      setUyariTip('error');
      setUyari(true);
      return;
    }

    if (bankNoInput.includes(',')) {
      setResponseMessage({
        ErrorCode: '1000',
        ErrorDescription: 'Mail göndermek için tek bir banka no seçilmiş olmalıdır!'
      });
      setUyariTip('error');
      setUyari(true);
      return;
    }

    if (!file) {
      setResponseMessage({
        ErrorCode: '1000',
        ErrorDescription: 'Lütfen önce dosya seçiniz!'
      });
      setUyariTip('error');
      setUyari(true);
      return;
    }

    const data = {
      BankaNo: parseInt(bankNoInput)
    };

    setLoading(true);
    axios.post('/SendDocumentBulletinMail', data)
      .then(response => {
        const result = response.data;
        if (result.ErrorCode === '0') {
          setResponseMessage({
            ErrorCode: result.ErrorCode,
            ErrorDescription: result.ErrorDescription
          });
          setUyariTip('success');
          setUyari(true);
        } else {
          setResponseMessage({
            ErrorCode: result.ErrorCode,
            ErrorDescription: result.ErrorDescription || 'Mail gönderilemedi!'
          });
          setUyariTip('error');
          setUyari(true);
        }
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  }

  return (
    <Page1 className={classes.root} title={'Döküman Yönetimi'}>
      <ThemeCustomization>
        <Backdrop className={classes.backdrop} open={loading}>
          <CircularProgress color="inherit" />
        </Backdrop>
        <Snackbar
          open={uyari}
          autoHideDuration={10000}
          onClose={uyariKapat}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        >
          <Alert
            onClose={uyariKapat}
            variant={uyariTip}
            message={responseMessage.ErrorDescription}
          />
        </Snackbar>
        <Container maxWidth="xl">
          <Card>
            <CardHeader title="Döküman Yönetimi" />
            <Divider />
            <CardContent>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12} md={6}>
                  <Card>
                    <Divider />
                    <CardActions sx={{ justifyContent: 'flex-end' }}>
                      <Grid container spacing={1}>
                        <Grid item xs={12} sm={12} lg={12}>
                          <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: 1,
                              mt: 3,
                              mb: 1.5,
                              px: 2,
                              py: 1.2,
                              borderRadius: 2,
                              bgcolor: '#f8f9fa',
                              border: '1px solid #e0e0e0',
                              borderLeft: '4px solid #FF9800',
                            }}
                          >
                            <FolderOpenIcon sx={{ color: '#FF9800', fontSize: 22 }} />
                            <Typography variant="subtitle1" sx={{ fontWeight: 700, color: 'text.primary', letterSpacing: 0.3 }}>
                              Geçmiş Yüklenen Dosyalar
                            </Typography>
                          </Box>
                          <Divider sx={{ mb: 2 }} />
                        </Grid>
                        <Grid item xs={12} sm={12} lg={6}>
                          <ThemeProvider theme={materialTheme}>
                            <MuiPickersUtilsProvider
                              utils={DateFnsUtils}
                              locale={localeMap['tr']}
                            >
                              <KeyboardDatePicker
                                fullWidth
                                size="small"
                                color="primary"
                                inputVariant="outlined"
                                label={'Başlangıç tarihi'}
                                invalidDateMessage={'Hatalı Tarih Formatı'}
                                format={'dd.MM.yyyy'}
                                value={talepEdilmeBaslangicTarihi}
                                variant="outlined"
                                onChange={date => {
                                  setTalepEdilmeBaslangicTarihi(date);
                                }}
                                KeyboardButtonProps={{
                                  'aria-label': 'change date'
                                }}
                              />
                            </MuiPickersUtilsProvider>
                          </ThemeProvider>
                        </Grid>
                        <Grid item xs={12} sm={12} lg={6}>
                          <ThemeProvider theme={materialTheme}>
                            <MuiPickersUtilsProvider
                              utils={DateFnsUtils}
                              locale={localeMap['tr']}
                            >
                              <KeyboardDatePicker
                                fullWidth
                                size="small"
                                color="primary"
                                inputVariant="outlined"
                                label={'Bitiş tarihi'}
                                invalidDateMessage={'Hatalı Tarih Formatı'}
                                format={'dd.MM.yyyy'}
                                value={talepEdilmeBitisTarihi}
                                variant="outlined"
                                onChange={date => {
                                  setTalepEdilmeBitisTarihi(date);
                                }}
                                KeyboardButtonProps={{
                                  'aria-label': 'change date'
                                }}
                              />
                            </MuiPickersUtilsProvider>
                          </ThemeProvider>
                        </Grid>
                        <Grid item xs={12} sm={12} md={12}>
                          <Autocomplete
                            options={mainGroups}
                            getOptionLabel={(option) => option?.ANA_GRUP || ""}
                            value={selectedMainGroupFilter}
                            onChange={(event, newValue) => {
                              setSelectedMainGroupFilter(newValue);
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Ürün Grubu"
                                variant="outlined"
                                InputProps={{
                                  ...params.InputProps,
                                  endAdornment: (
                                    <>
                                      {mainGroupLoading ? <CircularProgress color="primary" size={20} /> : null}
                                      {params.InputProps.endAdornment}
                                    </>
                                  ),
                                }}
                              />
                            )}
                            sx={{
                              "& .MuiAutocomplete-endAdornment": {
                                top: "50%",
                                transform: "translateY(-50%)",
                              },
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={12} md={12}>
                          <Autocomplete
                            options={bankTypes}
                            getOptionLabel={(option) => option.ACIKLAMA || ""}
                            value={selectedBankFilterType}
                            onChange={(event, newValue) => {
                              setSelectedBankFilterType(newValue);
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Banka Tipi"
                                variant="outlined"
                                InputProps={{
                                  ...params.InputProps,
                                  endAdornment: (
                                    <>
                                      {banktypeLoading ? <CircularProgress color="primary" size={20} /> : null}
                                      {params.InputProps.endAdornment}
                                    </>
                                  ),
                                }}
                              />
                            )}
                            sx={{
                              "& .MuiAutocomplete-endAdornment": {
                                top: "50%",
                                transform: "translateY(-50%)",
                              },
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={12} md={12}>
                          <Autocomplete
                            options={
                              documentList.filter(doc => {
                                const bankMatch = selectedBankFilterType?.BANKATIPI ? doc.BANKATIPI === selectedBankFilterType.BANKATIPI : true;
                                const groupMatch = selectedMainGroupFilter?.ANA_GRUP_KODU ? doc.URUNGRUBU === selectedMainGroupFilter.ANA_GRUP_KODU : true;
                                return bankMatch && groupMatch;
                              })
                            }
                            value={documentList.find(doc => String(doc.BANKA_NO) === bankNoInput) || null}
                            getOptionLabel={(option) => option.DOSYA_ADI}
                            onChange={(event, newValue) => {
                              handleChangeSelectedDocument(event, newValue);
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Dosya Seç"
                                variant="outlined"
                                InputProps={{
                                  ...params.InputProps,
                                  endAdornment: (
                                    <>
                                      {documentLoading ? <CircularProgress color="primary" size={20} /> : null}
                                      {params.InputProps.endAdornment}
                                    </>
                                  ),
                                }}
                              />
                            )}
                            sx={{
                              '& .MuiAutocomplete-endAdornment': {
                                top: '50%',
                                transform: 'translateY(-50%)',
                              }
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={12} md={12}>
                          <Autocomplete
                            options={productsData || []}
                            getOptionLabel={(option) => option.TANIM || ''}
                            value={selectedProduct || null}
                            inputValue={productInputValue}
                            onInputChange={(e, newValue, reason) => {
                              setProductInputValue(newValue ?? "");
                              if (reason === "input") {
                                if ((newValue?.length ?? 0) > 2) {
                                  handleGetProductsBySearchTerm(newValue);
                                }
                              }
                              if (reason === "clear") {
                                handleChangeSelectedProduct(e, null);
                                setProductInputValue("");
                                setBankNoInput("");
                              }
                            }}
                            isOptionEqualToValue={(option, value) =>
                              option.MODEL_KODU === value.MODEL_KODU
                            }
                            onChange={(event, newValue) => {
                              handleChangeSelectedProduct(event, newValue);
                              if (newValue) {
                                setProductInputValue(newValue["ACIKLAMA"] ?? "");
                              } else {
                                setProductInputValue("");
                              }
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Ürün Ara"
                                placeholder="Ürün Model Kodu ya da açıklaması ile arama yapabilirsiniz..."
                                InputProps={{
                                  ...params.InputProps,
                                  endAdornment: (
                                    <>
                                      {productLoading ? <CircularProgress size={18} /> : null}
                                      {params.InputProps.endAdornment}
                                    </>
                                  ),
                                }}
                              />
                            )}
                            sx={{
                              '& .MuiAutocomplete-endAdornment': {
                                top: '50%',
                                transform: 'translateY(-50%)',
                              }
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={12} md={6}>
                          <Button
                            variant="contained"
                            color="secondary"
                            fullWidth
                            className={classes.button}
                            endIcon={<SearchIcon />}
                            onClick={() => { handleGetStatusOfDocument(); }}
                          >
                            Sorgula
                          </Button>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6}>
                          <Button
                            variant="contained"
                            color="secondary"
                            fullWidth
                            className={classes.button}
                            onClick={() => { handleChatBox(); }}
                          >
                            Chat
                          </Button>
                        </Grid>
                        {documentBankNoList.length > 0 && (
                          <Grid item xs={12}>
                            <Paper
                              elevation={0}
                              sx={{
                                mt: 4,
                                border: '1px solid #e0e0e0',
                                borderRadius: 3,
                                overflow: 'hidden',
                                boxShadow: '0px 4px 24px rgba(0, 0, 0, 0.06)'
                              }}
                            >
                              <Box
                                sx={{
                                  bgcolor: '#fcfcfc',
                                  p: 2,
                                  display: 'flex',
                                  alignItems: 'center',
                                  borderBottom: '1px solid #e0e0e0'
                                }}
                              >
                                <FolderOpenIcon sx={{ color: 'primary.main', mr: 1.5 }} />
                                <Typography variant="subtitle1" sx={{ fontWeight: 700, color: 'text.primary' }}>
                                  Ürün Dosya Listesi
                                </Typography>
                                <Chip
                                  label={`${documentBankNoList.length} Dosya`}
                                  size="small"
                                  sx={{ ml: 2, bgcolor: '#e3f2fd', color: 'primary.main', fontWeight: 600, borderRadius: 1 }}
                                />
                              </Box>
                              <TableContainer sx={{ maxHeight: 450 }}>
                                <Table stickyHeader size="small">
                                  <TableHead>
                                    <TableRow>
                                      <TableCell sx={{ bgcolor: '#f8f9fa', py: 2 }}>
                                        <TableSortLabel
                                          active={orderBy === 'BANKAKODU'}
                                          direction={orderBy === 'BANKAKODU' ? order : 'asc'}
                                          onClick={createSortHandler('BANKAKODU')}
                                          sx={{ fontWeight: 600, color: 'text.secondary' }}
                                        >
                                          Dosya Adı
                                        </TableSortLabel>
                                      </TableCell>
                                      <TableCell sx={{ bgcolor: '#f8f9fa', width: '180px' }}>
                                        <TableSortLabel
                                          active={orderBy === 'BANKANO'}
                                          direction={orderBy === 'BANKANO' ? order : 'asc'}
                                          onClick={createSortHandler('BANKANO')}
                                          sx={{ fontWeight: 600, color: 'text.secondary' }}
                                        >
                                          Banka No
                                        </TableSortLabel>
                                      </TableCell>
                                    </TableRow>
                                  </TableHead>

                                  <TableBody>
                                    {stableSort(documentBankNoList, getComparator(order, orderBy)).map((bank, index) => (
                                      <TableRow
                                        hover
                                        key={bank.BANKANO || index}
                                        onClick={() => {
                                          if (loadingBankNo) return;
                                          const filename = bank.BANKANO + ".pdf";
                                          setFileName(filename);
                                          openDocumentInline(bank.BANKANO);
                                        }}
                                        sx={{
                                          cursor: loadingBankNo === bank.BANKANO ? 'wait' : 'pointer',
                                          backgroundColor: loadingBankNo === bank.BANKANO ? '#e8f4fd' : 'inherit',
                                          opacity: loadingBankNo && loadingBankNo !== bank.BANKANO ? 0.5 : 1,
                                          '&:hover': {
                                            backgroundColor: loadingBankNo === bank.BANKANO ? '#e8f4fd !important' : '#e8f4fd !important',
                                          },
                                          transition: 'background-color 0.15s ease, opacity 0.2s ease'
                                        }}
                                      >
                                        {/* Dosya Adı (İkonlu) */}
                                        <TableCell>
                                          <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                            <Tooltip
                                              title={loadingBankNo === bank.BANKANO ? 'PDF yükleniyor...' : "PDF'yi Görüntüle"}
                                              arrow
                                              placement="right"
                                            >
                                              <Box
                                                sx={{
                                                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                                                  width: 32, height: 32, borderRadius: 1.5,
                                                  bgcolor: loadingBankNo === bank.BANKANO ? 'primary.main' : '#e3f2fd',
                                                  color: loadingBankNo === bank.BANKANO ? '#fff' : 'primary.main',
                                                  mr: 2,
                                                  transition: 'all 0.2s ease',
                                                  '&:hover': {
                                                    bgcolor: 'primary.main',
                                                    color: '#fff',
                                                    transform: 'scale(1.1)',
                                                    boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
                                                  }
                                                }}
                                              >
                                                {loadingBankNo === bank.BANKANO
                                                  ? <CircularProgress size={16} sx={{ color: '#fff' }} />
                                                  : <InsertDriveFileIcon fontSize="small" />
                                                }
                                              </Box>
                                            </Tooltip>
                                            <Box>
                                              <Typography variant="body2" sx={{ fontWeight: 500, color: '#424242', lineHeight: 1.4 }}>
                                                {bank.BANKAKODU}
                                              </Typography>
                                              {loadingBankNo === bank.BANKANO && (
                                                <Chip
                                                  icon={<CircularProgress size={10} sx={{ color: 'primary.main !important', ml: '6px !important' }} />}
                                                  label="PDF açılıyor..."
                                                  size="small"
                                                  sx={{
                                                    mt: 0.5,
                                                    height: 20,
                                                    fontSize: '0.68rem',
                                                    fontWeight: 600,
                                                    bgcolor: '#e3f2fd',
                                                    color: 'primary.main',
                                                    border: '1px solid',
                                                    borderColor: 'primary.light',
                                                    borderRadius: 1,
                                                    '& .MuiChip-label': { px: 1 }
                                                  }}
                                                />
                                              )}
                                            </Box>
                                          </Box>
                                        </TableCell>

                                        {/* Banka No (Renkli Chip) */}
                                        <TableCell>
                                          <Chip
                                            label={bank.BANKANO}
                                            size="small"
                                            sx={{
                                              borderRadius: 1.5,
                                              bgcolor: '#fff3e0',
                                              color: '#ef6c00',
                                              fontWeight: 600,
                                              border: '1px solid #ffe0b2'
                                            }}
                                          />
                                        </TableCell>

                                      </TableRow>
                                    ))}
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            </Paper>
                          </Grid>
                        )}
                        <Grid item xs={12} sm={12} md={12}>
                          <Divider />
                        </Grid>
                        <Grid item xs={12} sm={12} lg={12}>
                          <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'space-between',
                              mt: 3,
                              mb: 1.5,
                              px: 2,
                              py: 1.2,
                              borderRadius: 2,
                              bgcolor: '#f8f9fa',
                              border: '1px solid #e0e0e0',
                              borderLeft: '4px solid',
                              borderLeftColor: teknisyenKocuAktiflik === null
                                ? 'grey.400'
                                : teknisyenKocuAktiflik ? '#43a047' : '#e53935',
                            }}
                          >
                            <Typography variant="subtitle1" sx={{ fontWeight: 700, color: 'text.primary', letterSpacing: 0.3 }}>
                              Dosya Bilgileri
                            </Typography>
                            {teknisyenKocuAktiflik !== null && (() => {
                              const canToggle = [1, 15, 16, 17, 21, 22].includes(Number(selectedBankType?.BANKATIPI));
                              return (
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
                                  {/* Mevcut durum göstergesi */}
                                  <Typography variant="caption" sx={{ fontWeight: 600, color: 'text.secondary', whiteSpace: 'nowrap' }}>
                                    Teknisyen Koçu:
                                  </Typography>
                                  <Chip
                                    icon={teknisyenKocuAktiflik ? <CheckCircleIcon fontSize="small" /> : <CancelIcon fontSize="small" />}
                                    label={teknisyenKocuAktiflik ? 'Aktif' : 'Pasif'}
                                    size="small"
                                    sx={{
                                      fontWeight: 700,
                                      borderRadius: 1.5,
                                      px: 0.5,
                                      cursor: 'default',
                                      bgcolor: teknisyenKocuAktiflik ? '#e8f5e9' : '#ffebee',
                                      color: teknisyenKocuAktiflik ? '#2e7d32' : '#c62828',
                                      border: '1px solid',
                                      borderColor: teknisyenKocuAktiflik ? '#a5d6a7' : '#ef9a9a',
                                      boxShadow: teknisyenKocuAktiflik
                                        ? '0 1px 6px rgba(67,160,71,0.2)'
                                        : '0 1px 6px rgba(229,57,53,0.2)',
                                      '& .MuiChip-icon': {
                                        color: teknisyenKocuAktiflik ? '#2e7d32' : '#c62828'
                                      }
                                    }}
                                  />
                                  {/* Eylem butonu */}
                                  <Tooltip
                                    title={!canToggle ? 'Bu banka tipi için durum değiştirilemez' : ''}
                                    arrow
                                  >
                                    <span>
                                      <Chip
                                        icon={teknisyenKocuAktiflik ? <CancelIcon fontSize="small" /> : <CheckCircleIcon fontSize="small" />}
                                        label={teknisyenKocuAktiflik ? 'Pasife Al' : 'Aktife Al'}
                                        size="small"
                                        onClick={canToggle ? () => handleToggleAktiflik(!teknisyenKocuAktiflik) : undefined}
                                        sx={{
                                          fontWeight: 700,
                                          borderRadius: 1.5,
                                          px: 0.5,
                                          cursor: canToggle ? 'pointer' : 'default',
                                          opacity: canToggle ? 1 : 0.45,
                                          bgcolor: teknisyenKocuAktiflik ? '#fff3e0' : '#e3f2fd',
                                          color: teknisyenKocuAktiflik ? '#e65100' : '#1565c0',
                                          border: '1px solid',
                                          borderColor: teknisyenKocuAktiflik ? '#ffcc80' : '#90caf9',
                                          ...(canToggle && {
                                            '&:hover': {
                                              bgcolor: teknisyenKocuAktiflik ? '#ffe0b2' : '#bbdefb',
                                              borderColor: teknisyenKocuAktiflik ? '#ffa726' : '#64b5f6',
                                            }
                                          }),
                                          '& .MuiChip-icon': {
                                            color: teknisyenKocuAktiflik ? '#e65100' : '#1565c0'
                                          }
                                        }}
                                      />
                                    </span>
                                  </Tooltip>
                                </Box>
                              );
                            })()}
                          </Box>
                          <Divider sx={{ mb: 2 }} />
                        </Grid>
                        <Grid item xs={12} sm={12} md={6}>
                          <Autocomplete
                            options={bankTypes}
                            getOptionLabel={(option) => option.ACIKLAMA || ""}
                            value={selectedBankType}
                            onChange={(event, newValue) => {
                              handleChangeBankType(newValue);
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Banka Tipi"
                                variant="outlined"
                                InputProps={{
                                  ...params.InputProps,
                                  endAdornment: (
                                    <>
                                      {banktypeLoading ? <CircularProgress color="primary" size={20} /> : null}
                                      {params.InputProps.endAdornment}
                                    </>
                                  ),
                                }}
                              />
                            )}
                            sx={{
                              "& .MuiAutocomplete-endAdornment": {
                                top: "50%",
                                transform: "translateY(-50%)",
                              },
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={12} md={6}>
                          <Autocomplete
                            options={mainGroups}
                            value={selectedMainGroups}
                            getOptionLabel={(option) => option?.ANA_GRUP || ""}
                            onChange={(event, newValue) => {
                              setSelectedMainGroups(newValue);
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Ürün Grubu"
                                variant="outlined"
                                InputProps={{
                                  ...params.InputProps,
                                  endAdornment: (
                                    <>
                                      {mainGroupLoading ? <CircularProgress color="primary" size={20} /> : null}
                                      {params.InputProps.endAdornment}
                                    </>
                                  ),
                                }}
                              />
                            )}
                            sx={{
                              "& .MuiAutocomplete-endAdornment": {
                                top: "50%",
                                transform: "translateY(-50%)",
                              },
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6} md={6}>
                          <TextField
                            variant="outlined"
                            type="text"
                            label="Banka Kodu"
                            fullWidth
                            size='small'
                            value={bankaKodu}
                            onChange={(e) => { setBankaKodu(e.target.value); }}
                            inputProps={{ maxLength: 50 }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6} md={6}>
                          <TextField
                            variant="outlined"
                            type="text"
                            label="Dosya Link Alanı"
                            fullWidth
                            size='small'
                            value={dosyaLinkAciklamaInput}
                            onChange={(e) => { setDosyaLinkAciklamaInput(e.target.value); }}
                            inputProps={{ maxLength: 255 }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={12} md={9}>
                          <TextField
                            variant="outlined"
                            type="text"
                            label="Dosya Açıklaması"
                            fullWidth
                            size='small'
                            value={bankaAciklamaInput}
                            onChange={(e) => { setBankaAciklamaInput(e.target.value); }}
                            inputProps={{ maxLength: 255 }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={12} md={3}>
                          <TextField
                            variant="outlined"
                            type="text"
                            label="Banka Numarası"
                            disabled
                            fullWidth
                            size='small'
                            value={bankNoInput}
                          />
                        </Grid>
                        <Grid item xs={11} sm={11} md={11}
                          marginTop={2}
                        >
                          <Autocomplete
                            multiple
                            options={models}
                            value={selectedModels || []}
                            renderTags={() => null}
                            isOptionEqualToValue={(option, value) => option.MODEL_KODU === value.MODEL_KODU}
                            getOptionLabel={(option) => option?.ACIKLAMA || ""}
                            onChange={(event, newValue) => {
                              setSelectedModels(newValue);
                            }}
                            onInputChange={(event, newInputValue, reason) => {
                              if (reason === "input" && (newInputValue.length > 2 || newInputValue.length === 0)) {
                                getModels(newInputValue);
                              }
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Eşlenecek Grup/Model Ekle"
                                placeholder={selectedModels?.length > 0 ? "Başka model ekle..." : "Model ara..."}
                                variant="outlined"
                                InputProps={{
                                  ...params.InputProps,
                                  endAdornment: (
                                    <>
                                      {modelLoading ? <CircularProgress color="primary" size={20} /> : null}
                                      {params.InputProps.endAdornment}
                                    </>
                                  ),
                                }}
                              />
                            )}
                            sx={{
                              "& .MuiAutocomplete-endAdornment": {
                                top: "50%",
                                transform: "translateY(-50%)",
                              },
                            }}
                          />
                        </Grid>
                        <Grid
                          item xs={1} sm={1} md={1}
                          container
                          alignItems="center"
                          justifyContent="flex-start"
                          marginTop={2}
                        >
                          <IconButton onClick={() => setBulkModelUploadPopUp(true)}>
                            <LibraryAddIcon />
                          </IconButton>
                        </Grid>
                        {selectedModels && selectedModels.length > 0 && (
                          <Grid item xs={12} sm={12} md={12}>
                            <Paper
                              elevation={0}
                              sx={{
                                border: '1px solid',
                                borderColor: '#e0e0e0',
                                borderRadius: 3,
                                overflow: 'hidden',
                                boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.05)'
                              }}
                            >
                              <Box
                                sx={{
                                  bgcolor: '#f8f9fa',
                                  p: 2,
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'space-between',
                                  borderBottom: '1px solid',
                                  borderColor: '#e0e0e0'
                                }}
                              >
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                  <PlaylistAddCheckIcon color="primary" sx={{ mr: 1.5 }} />
                                  <Typography variant="subtitle1" sx={{ fontWeight: 600, color: 'text.primary' }}>
                                    Seçili Modeller
                                  </Typography>
                                  <Chip
                                    label={`${selectedModels.length} Adet`}
                                    size="small"
                                    color="primary"
                                    sx={{ ml: 2, borderRadius: 1, fontWeight: 'bold', height: 24 }}
                                  />
                                </Box>
                              </Box>
                              <TableContainer sx={{ maxHeight: 350 }}>
                                <Table size="small" stickyHeader>
                                  <TableHead>
                                    <TableRow>
                                      <TableCell sx={{ bgcolor: '#f8f9fa', width: '25%', py: 1.5 }}>
                                        <TableSortLabel
                                          active={modelOrderBy === 'KUL_MODEL_KODU'}
                                          direction={modelOrderBy === 'KUL_MODEL_KODU' ? modelOrder : 'asc'}
                                          onClick={createModelSortHandler('KUL_MODEL_KODU')}
                                          sx={{ fontWeight: 600, color: 'text.secondary' }}
                                        >
                                          Model Kodu
                                        </TableSortLabel>
                                      </TableCell>
                                      <TableCell sx={{ bgcolor: '#f8f9fa' }}>
                                        <TableSortLabel
                                          active={modelOrderBy === 'ACIKLAMA'}
                                          direction={modelOrderBy === 'ACIKLAMA' ? modelOrder : 'asc'}
                                          onClick={createModelSortHandler('ACIKLAMA')}
                                          sx={{ fontWeight: 600, color: 'text.secondary' }}
                                        >
                                          Açıklama
                                        </TableSortLabel>
                                      </TableCell>
                                      <TableCell align="right" sx={{ bgcolor: '#f8f9fa', width: 60, fontWeight: 600, color: 'text.secondary' }}>
                                        İşlem
                                      </TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {stableSort(selectedModels, getComparator(modelOrder, modelOrderBy)).map((model, index) => (
                                      <TableRow
                                        key={model.KUL_MODEL_KODU || index}
                                        sx={{
                                          '&:hover': { backgroundColor: '#f5f5f5' },
                                          transition: 'background-color 0.2s'
                                        }}
                                      >
                                        <TableCell>
                                          <Chip
                                            label={model.KUL_MODEL_KODU}
                                            size="small"
                                            variant="outlined"
                                            sx={{
                                              fontWeight: 600,
                                              borderRadius: 1.5,
                                              color: 'primary.main',
                                              borderColor: 'primary.light',
                                              bgcolor: '#e3f2fd'
                                            }}
                                          />
                                        </TableCell>
                                        <TableCell sx={{ color: 'text.secondary', fontSize: '0.875rem', fontWeight: 500 }}>
                                          {model.ACIKLAMA}
                                        </TableCell>
                                        <TableCell align="right">
                                          <Tooltip title="Listeden Kaldır" arrow>
                                            <IconButton
                                              size="small"
                                              onClick={() => handleRemoveModel(model)}
                                              sx={{
                                                color: 'text.disabled',
                                                '&:hover': {
                                                  color: 'error.main',
                                                  bgcolor: '#ffebee'
                                                },
                                                transition: 'all 0.2s'
                                              }}
                                            >
                                              <DeleteOutlineIcon fontSize="small" />
                                            </IconButton>
                                          </Tooltip>
                                        </TableCell>
                                      </TableRow>
                                    ))}
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            </Paper>
                          </Grid>
                        )}
                        <Grid item xs={12} sm={12} md={12}>
                          <Divider sx={{ mb: 4, mt: 4 }} />
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={3}>
                          <Button
                            className={classes.button}
                            variant="contained"
                            color="secondary"
                            fullWidth
                            endIcon={<SaveIcon />}
                            onClick={() => { handleUpdateDocument() }}
                          >
                            KAYDET
                          </Button>
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={3}>
                          <Button
                            className={classes.button}
                            variant="contained"
                            color="secondary"
                            fullWidth
                            endIcon={<AddIcon />}
                            onClick={() => { handleClearEverything() }}
                          >
                            YENİ
                          </Button>
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={4}>
                          <input
                            id='fileUpload'
                            type="file"
                            accept="application/pdf"
                            onChange={handleUploadFile}
                            onClick={(e) => e.target.value = null}
                            className="mt-2 p-2 border"
                            hidden
                          />
                          <label htmlFor="fileUpload">
                            <Button
                              className={classes.button}
                              variant="contained"
                              color="secondary"
                              fullWidth
                              component="span"
                              endIcon={<UploadFileIcon />}
                              onClick={(e) => {
                                if (!selectedMainGroups || !selectedMainGroups.ANA_GRUP_KODU ||
                                  !selectedBankType || !selectedBankType.BANKATIPI ||
                                  !bankaAciklamaInput || !bankaAciklamaInput.trim() || selectedModels.length <= 0) {

                                  e.preventDefault(); // input’u açmayı engelle
                                  setResponseMessage({
                                    ErrorCode: '1000',
                                    ErrorDescription: 'Lütfen önce Ana Grup, Banka Tipi, Açıklama ve Eşlenecek Grup/Model Kodu alanlarını doldurunuz!'
                                  });
                                  setUyariTip('error');
                                  setUyari(true);
                                }
                              }}
                            >
                              Dosya Seç & Kaydet
                            </Button>
                          </label>
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={2}>
                          <Button
                            className={classes.button}
                            variant="contained"
                            color="secondary"
                            fullWidth
                            disabled={!file || !bankNoInput || bankNoInput.includes(',')}
                            endIcon={<EmailIcon />}
                            onClick={() => { handleSendMail(); }}
                          >
                            Mail
                          </Button>
                        </Grid>
                      </Grid>
                    </CardActions>
                    <Divider />
                    <CardContent style={{ height: '780px', padding: 0, position: "relative" }}>
                      {fileLoading && (
                        <div
                          style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            backgroundColor: "rgba(255, 255, 255, 0.7)", // opsiyonel blur effect
                          }}
                        >
                          <CircularProgress size={40} />
                          <span style={{ marginLeft: "12px", fontSize: "16px" }}>
                            PDF yükleniyor, lütfen bekleyiniz...
                          </span>
                        </div>
                      )}
                      {file && (
                        <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                          <div style={{ borderBottom: '1px solid #ddd', padding: '4px' }}>
                            <Toolbar>
                              {(slots) => {
                                const {
                                  ZoomIn,
                                  ZoomOut,
                                  Zoom,
                                  GoToNextPage,
                                  GoToPreviousPage,
                                  CurrentPageInput,
                                  NumberOfPages,
                                  Download,
                                  ShowSearchPopover,
                                } = slots;

                                return (
                                  <div
                                    style={{
                                      display: 'flex',
                                      justifyContent: 'center',
                                      alignItems: 'center',
                                      width: '100%',
                                      flexWrap: 'wrap',
                                      gap: '12px',
                                    }}
                                  >
                                    {/* Grup 1: Arama + Download */}
                                    <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                                      <ShowSearchPopover />
                                      <Download />
                                    </div>

                                    {/* Grup 2: Sayfa kontrol */}
                                    <div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
                                      <GoToPreviousPage />
                                      <CurrentPageInput /> / <NumberOfPages />
                                      <GoToNextPage />
                                    </div>

                                    {/* Grup 3: Zoom */}
                                    <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                                      <ZoomOut />
                                      <Zoom />
                                      <ZoomIn />
                                    </div>
                                  </div>
                                );
                              }}
                            </Toolbar>
                          </div>
                          <div style={{ flex: 1, overflow: 'hidden' }}>
                            <Viewer fileUrl={file} plugins={[toolbarPluginInstance]} />
                          </div>
                        </div>
                      )}
                    </CardContent>
                  </Card>
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <Card>
                    <Divider />
                    <CardActions sx={{ justifyContent: 'flex-end' }}>
                      <Box sx={{ width: "100%" }}>
                        <Stepper activeStep={activeStep} nonLinear alternativeLabel>
                          {steps.map((step, index) => (
                            <Step key={step.label}>
                              <StepButton
                                icon={step.icon}
                                onClick={() => handleStep(index, step.onClick)}
                                sx={{
                                  "& .MuiStepLabel-label": {
                                    color: activeStep === index ? "primary.main" : "text.secondary",
                                    fontWeight: activeStep === index ? "bold" : "normal",
                                  },
                                  "& .MuiSvgIcon-root": {
                                    color: activeStep === index ? "primary.main" : "inherit",
                                  },
                                }}
                              >
                                {step.label}
                              </StepButton>
                            </Step>
                          ))}
                        </Stepper>
                      </Box>

                    </CardActions>
                    <Divider />
                    <CardContent style={{ height: '780px', padding: 0, position: 'relative' }}>
                      {fileOutputLoading ? (
                        <div
                          style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            backgroundColor: "rgba(255, 255, 255, 0.7)",
                          }}
                        >
                          <CircularProgress size={40} />
                          <span style={{ marginLeft: "12px", fontSize: "16px" }}>
                            PDF yükleniyor, lütfen bekleyiniz...
                          </span>
                        </div>
                      ) : (
                        pdfUrl && (
                          <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                            <div style={{ borderBottom: '1px solid #ddd', padding: '4px' }}>
                              <Toolbar2>
                                {(slots) => {
                                  const {
                                    ZoomIn,
                                    ZoomOut,
                                    Zoom,
                                    GoToNextPage,
                                    GoToPreviousPage,
                                    CurrentPageInput,
                                    NumberOfPages,
                                    Download,
                                    ShowSearchPopover,
                                  } = slots;

                                  return (
                                    <div
                                      style={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        width: '100%',
                                        flexWrap: 'wrap',
                                        gap: '12px',
                                      }}
                                    >
                                      {/* Grup 1: Arama + Download */}
                                      <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                                        <ShowSearchPopover />
                                        <Download />
                                      </div>

                                      {/* Grup 2: Sayfa kontrol */}
                                      <div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
                                        <GoToPreviousPage />
                                        <CurrentPageInput /> / <NumberOfPages />
                                        <GoToNextPage />
                                      </div>

                                      {/* Grup 3: Zoom */}
                                      <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                                        <ZoomOut />
                                        <Zoom />
                                        <ZoomIn />
                                      </div>
                                    </div>
                                  );
                                }}
                              </Toolbar2>
                            </div>
                            <div style={{ flex: 1, overflow: 'hidden' }}>
                              <Viewer fileUrl={pdfUrl} plugins={[toolbarPluginInstance2]} />
                            </div>
                          </div>
                        ))}
                    </CardContent>
                    <Divider />
                  </Card>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Container>
        {/* Add Modal component here */}
        <Modal
          open={openModal}
          onClose={() => setOpenModal(false)}
          aria-labelledby="modal-title"
          aria-describedby="modal-description"
        >
          <Box sx={modalStyle}>
            <Typography id="modal-title" variant="h6" component="h2" gutterBottom>
              İşlenmiş PDF İçeriği
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Box id="modal-description" sx={{ mb: 2 }}>
              <TextField
                fullWidth
                multiline
                rows={10}
                defaultValue="Henüz Promt Yok!..."
                variant="outlined"
                sx={{
                  '& .MuiOutlinedInput-root': {
                    '& fieldset': {
                      borderColor: 'grey.400',
                    },
                  },
                }}
              />
            </Box>
            <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
              <Button
                variant="contained"
                color="secondary"
                onClick={() => setOpenModal(false)}
                endIcon={<CloseIcon>send</CloseIcon>}
              >
                Kapat
              </Button>
            </Box>
          </Box>
        </Modal>
      </ThemeCustomization>
      <Dialog
        open={documentSummaryPopUp}
        onClose={() => setDocumentSummaryPopUp(false)}
        maxWidth="lg"
        fullWidth
      >
        <DialogTitle>{"Döküman Özeti"}</DialogTitle>
        <DialogContent dividers>
          <Stack spacing={2}>
            <Stack direction="row" spacing={1} alignItems="center">
              <Typography variant="subtitle2">{'Durum:'}</Typography>
              <Chip
                label={documentStatusData?.status}
                color={documentStatusData?.status === "Synced" ? "success" : "info"}
                size="small"
              />
            </Stack>

            <Stack spacing={0.5}>
              <Typography variant="subtitle2">{'Özet:'}</Typography>
              <Typography variant="body2" color="text.secondary" align='justify'>
                {documentStatusData?.summary ? documentStatusData?.summary : 'Özet şu anda gelmiyor AI Ekibi servise ekleyecek...'}
              </Typography>
            </Stack>

            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={4}>
              <Stack>
                <Typography variant="subtitle2">{'Oluşturulma Tarihi:'}</Typography>
                <Typography variant="body2" color="text.secondary">
                  {documentStatusData?.latestProcessedVersionCreatedAt ?
                    new Date(documentStatusData?.latestProcessedVersionCreatedAt).toLocaleString() : '-'}
                </Typography>
              </Stack>

              <Stack>
                <Typography variant="subtitle2">{'Onaylanma Tarihi:'}</Typography>
                <Typography variant="body2" color="text.secondary">
                  {documentStatusData?.latestProcessedVersionApprovedAt ?
                    new Date(documentStatusData?.latestProcessedVersionApprovedAt).toLocaleString() : '-'}
                </Typography>
              </Stack>

              <Stack>
                <Typography variant="subtitle2">{'İşlem Bitiş Tarihi:'}</Typography>
                <Typography variant="body2" color="text.secondary">
                  {documentStatusData?.latestProcessedVersionProcessingFinishedAt ?
                    new Date(documentStatusData?.latestProcessedVersionProcessingFinishedAt).toLocaleString() : '-'}
                </Typography>
              </Stack>

              <Stack>
                <Typography variant="subtitle2">{'Versiyon:'}</Typography>
                <Typography variant="body2" color="text.secondary">
                  {documentStatusData?.latestProcessedVersionNumber ? documentStatusData?.latestProcessedVersionNumber : '-'}
                </Typography>
              </Stack>
            </Stack>
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setDocumentSummaryPopUp(false)}
            color="primary"
            autoFocus
          >
            Kapat
          </Button>
        </DialogActions>
      </Dialog >
      <Dialog
        open={bulkModelUploadPopUp}
        onClose={() => setBulkModelUploadPopUp(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>{"Toplu Model Yükleme"}</DialogTitle>
        <DialogContent dividers>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                label='Toplu Model Kodları'
                placeholder='Lütfen model kodlarını boşluk bırakarak alt alta giriniz.'
                variant='outlined'
                fullWidth
                multiline
                minRows={15}
                value={bulkUserModelCodes}
                onChange={(event) => { setBulkUserModelCodes(event.target.value); }}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => handleSaveBulkUserModelCodes()}
            color="secondary"
            variant="contained"
            disabled={bulkUserModelCodeLoading}
            autoFocus
            sx={{ gap: 1 }}
          >
            {"Kaydet"}
            {bulkUserModelCodeLoading && <CircularProgress size={20} color="inherit" />}
          </Button>

          <Button
            onClick={() => setBulkModelUploadPopUp(false)}
            color="primary"
            autoFocus
          >
            Kapat
          </Button>
        </DialogActions>
      </Dialog >
      <Dialog open={confirmDialogOpen} onClose={handleConfirmDialogClose}>
        <DialogTitle>Emin misiniz?</DialogTitle>
        <DialogContent>
          <DialogContentText>Bu işlemi geri alamazsınız. Devam etmek istiyor musunuz?</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleConfirmDialogClose} color="primary">Hayır</Button>
          <Button onClick={handleConfirmDialogConfirm} color="secondary" variant="contained">Evet</Button>
        </DialogActions>
      </Dialog>

      {techGptPopUp && (
        <TechGptChatbox
          open={techGptPopUp}
          onClose={() => setTechGptPopUp(false)}
          bankaNo={bankNoInput}
        />
      )}
    </Page1 >
  );
};

export default FileManagement;